const config = {
  NotificationConfig: {
    DefaultAutoHide: 2000,
    PersistAllNotifications: false,
    PersistErrorNotifications: true,
  },
  ObxRoles: {
    Administrator: 'Administrator',
    CareCoordinator: 'Care Coordinator',
    CareCoordinatorManager: 'Care Coordinator Manager',
    GeneralFinance: 'General Finance',
    FinanceTier1: 'Finance Tier 1',
    FinanceTier2: 'Finance Tier 2',
    FinanceTier3: 'Finance Tier 3',
    ProviderInfoUpdater: 'Provider Info Updater',
    WorkflowAdmin: 'Workflow Admin',
    FinanceManager: 'Finance Manager',
  },
  OmxRoles: {
    CaseManager: 'Case Manager',
    CaseCoordinator: 'Case Coordinator',
  },
}

export default config
